/*
export function someGetter (state) {
}
*/

export function hasPermissions(state) {
  return (permissions) => {
    const user = state.user;

    if (!user) {
      return false;
    }

    const roleCode = user.role?.code;

    if (["admin", "owner"].includes(roleCode)) {
      return true;
    }

    if (!Array.isArray(permissions)) {
      permissions = [permissions];
    }

    // Effective set mirrors backend User::getEffectivePermissions():
    const overrides = user.permission_overrides || [];
    const userPermissions = user.permissions || [];
    const companyRolePermissions = user.company_role?.permissions || [];

    for (let i = 0; i < permissions.length; i++) {
      const code = permissions[i];

      if (overrides.find((p) => p.code === code)) {
        return false;
      }

      if (
        !userPermissions.find((p) => p.code === code) &&
        !companyRolePermissions.find((p) => p.code === code)
      ) {
        return false;
      }
    }

    return true;
  };
}
